import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import LoadingSpinner from './Common/LoadingSpinner';
import { ROLE_LEVELS } from '../utils/roleUtils';

/**
 * 홈(/ 및 /dashboard) 진입 시 인증/역할에 따라 적절한 화면으로 보낸다.
 * - 비로그인 → 데모(메인 온보딩) 화면. 로그인은 온보딩 헤더의 "로그인" 버튼으로.
 * - 관리자 → 운영 현황 화면으로 바로 진입
 * - 스탭 → 멘토 포털(멘토와 동일한 기본 화면) — 관리자(수업운영) 페이지는 기본 진입점이
 *   아니고, 계정 관리 화면의 별도 버튼으로만 들어간다(AccountManagement.js 참조).
 * - 멘토/교사(roleLevel >= 3) → 멘토 포털
 * - 학습자(roleLevel >= 2) → 학생 프로젝트
 * - 그 외(일반 사용자) → 계정 관리
 */
function AuthedHome() {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!user) {
        // 메인 진입점 = 메인 온보딩 화면 (/main)
        return <Navigate to="/main" replace />;
    }

    if (user.isAdmin || user.role === 'admin') {
        return <Navigate to="/admin/overview" replace />;
    }

    // 스탭은 멘토와 동일하게 roleLevel >= TEACHER 분기를 타고 멘토 포털로 진입한다
    // (아래 분기가 그대로 처리 — 별도 분기 불필요).
    if ((user.roleLevel || 0) >= ROLE_LEVELS.TEACHER) {
        return <Navigate to="/instructor/dashboard" replace />;
    }

    if ((user.roleLevel || 0) >= ROLE_LEVELS.LEARNER) {
        return <Navigate to="/students/projects" replace />;
    }

    return <Navigate to="/account" replace />;
}

export default AuthedHome;
